import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../../molecules/RoundedModal'
import AddPresentationForm from './form'

const AddPresentationDialog = React.forwardRef(function AddPresentationDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false })

  const close = useCallback(() => {
    setDialogState({ open: false })
  }, [setDialogState])

  const handleComplete = useCallback((result) => {
    close()
    onComplete(result)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogState({ open: true })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Add Presentation'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <AddPresentationForm
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

AddPresentationDialog.propTypes = {
  onComplete: PropTypes.func
}

AddPresentationDialog.defaultProps = {
  onComplete: () => {}
}

export default AddPresentationDialog
